
(function(){
  /* Rendered once sitewide from the footer group. The latch is insurance: if a
     second copy ever appears, its script exits instead of binding a duplicate
     set of document-level listeners. */
  if (window.__lafsEnrollInit) return;
  window.__lafsEnrollInit = true;
  var ov = document.getElementById('lef-ov');
  if (!ov) return;
  var lastFocus = null;

  function open(srcLabel){
    var src = document.getElementById('lef-src');
    if (src && srcLabel) src.value = srcLabel;
    lastFocus = document.activeElement;
    preselect();
    ov.hidden = false;
    /* next frame so the transition runs */
    requestAnimationFrame(function(){ ov.classList.add('open'); });
    document.documentElement.style.overflow = 'hidden';
    var f = ov.querySelector('input,select,textarea,button');
    if (f) setTimeout(function(){ try { f.focus(); } catch(e){} }, 80);
  }
  function close(){
    ov.classList.remove('open');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ if (!ov.classList.contains('open')) ov.hidden = true; }, 240);
    if (lastFocus) { try { lastFocus.focus(); } catch(e){} }
  }
  window.lafsEnroll = open;

  /* Fallback course pre-selection. Pages that pre-select the course themselves
     (the course UX kit does, on its own capture-phase listener, which is bound
     before this one) win: we only fill an empty select. This exists so the
     pages whose body lives in page data rather than in the theme still open the
     modal with the right course showing. */
  var BYPATH = {
    'instrument-rating': 'Instrument Rating',
    'multi-engine': 'Multi-Engine Rating',
    'sport-pilot': 'Sport Pilot License',
    'private-pilot': 'Private Pilot Certificate',
    'commercial-pilot': 'Commercial Pilot',
    'airline-pilot': 'Airline Pilot Program',
    'teen': 'Teen Flight Training (Ages 10-15)',
    'discovery-flight': 'Discovery Flight'
  };
  function preselect(){
    var sel = document.getElementById('lef-prog');
    if (!sel || sel.value) return;
    var p = window.location.pathname;
    for (var k in BYPATH) { if (p.indexOf(k) > -1) { sel.value = BYPATH[k]; return; } }
  }

  /* "Claim ... discount / off" buttons enroll too. */
  var CLAIM = /\bclaim\b/i, CLAIMWHAT = /discount|\boff\b|\$\s?\d/i;
  function isClaim(el){
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName !== 'A' && el.tagName !== 'BUTTON') return false;
    if (el.hasAttribute('data-lafs-noenroll')) return false;
    var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return txt.length <= 60 && CLAIM.test(txt) && CLAIMWHAT.test(txt);
  }
  function noteClaim(el){
    var msg = document.getElementById('lef-body');
    if (!msg) return;
    var amt = ((el.textContent || '').match(/\$\s?[\d,]+/) || [''])[0].replace(/\s/g, '');
    var v = 'I would like to claim the ' + (amt ? amt + ' ' : '') + 'discount.';
    if (!msg.value || msg.value === msg.getAttribute('data-cux-auto')) {
      msg.value = v; msg.setAttribute('data-cux-auto', v);
    }
  }

  /* "Book A Free Consultation" -> the Cowlendar consultation calendar. */
  var CONSULT_VAR = '44666224705715', CONSULT_SVC = '6a5be35f2a0ec97b71709f81';
  var CONSULT_PAGE = '/pages/flight-school-van-nuys-free-in-person-consultation';
  var CWORD = /\bconsult(?:ation)?s?\b/i, CVERB = /\b(?:book|free|schedule)\b/i;
  function consultBtn(){
    var list = document.querySelectorAll('[class*="cowlendar-btn"]');
    for (var i = 0; i < list.length; i++) {
      var f = list[i].closest('form, .la-consult');
      if (f && f.querySelector('input[name="id"][value="' + CONSULT_VAR + '"]')) return list[i];
    }
    return document.querySelector('[data-cowlendar-btn*="' + CONSULT_VAR + '"]');
  }
  function isConsult(el){
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute('data-lafs-nobook')) return false;
    if (el.hasAttribute('data-lafs-book')) return true;
    if (el.tagName !== 'A' && el.tagName !== 'BUTTON') return false;
    if (el.type === 'submit') return false;
    /* Cowlendar's own buttons already open the calendar. */
    if (/cowlendar/.test(String(el.className || '')) || el.hasAttribute('data-cowlendar-btn')) return false;
    if (el.closest('.la-consult')) return false;
    var href = el.getAttribute('href') || '';
    if (href.indexOf(CONSULT_PAGE) > -1 || href.indexOf(CONSULT_SVC) > -1) return true;
    var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return txt.length <= 60 && CWORD.test(txt) && CVERB.test(txt);
  }

  /* Is this element an enrollment trigger? Text or href, either is enough. */
  var WORD = /\benrol{1,2}(?:ment|ing|s)?\b/i;
  function isTrigger(el){
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute('data-lafs-noenroll')) return false;
    if (el.hasAttribute('data-lafs-enroll')) return true;
    var tag = el.tagName;
    if (tag !== 'A' && tag !== 'BUTTON') return false;
    var href = el.getAttribute('href') || '';
    /* never hijack a real form submit or an anchor to the enrollment page's own content */
    if (el.type === 'submit') return false;
    if (WORD.test(href)) return true;
    var txt = (el.textContent || '').trim();
    if (txt.length > 40) return false;
    return WORD.test(txt);
  }

  document.addEventListener('click', function(e){
    if (ov.contains(e.target)) {
      if (e.target.id === 'lef-x' || e.target === ov) { e.preventDefault(); close(); }
      return;
    }
    var el = e.target;
    for (var i = 0; i < 5 && el && el !== document.body; i++) {
      var claim = !isTrigger(el) && isClaim(el);
      if (isTrigger(el) || claim) {
        e.preventDefault();
        e.stopPropagation();
        if (claim) noteClaim(el);
        var label = document.title + ' — ' + window.location.pathname;
        open(label);
        return;
      }
      if (isConsult(el)) {
        var cb = consultBtn();
        if (!cb) return;              /* calendar not ready: follow the link */
        e.preventDefault();
        e.stopPropagation();
        cb.click();
        return;
      }
      el = el.parentNode;
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && ov.classList.contains('open')) close();
  });

  /* Shopify redirects back with ?contact_posted=true — reopen so the thank-you shows. */
  if (window.location.search.indexOf('contact_posted=true') > -1) {
    open('');
    if (window.history && window.history.replaceState) {
      var clean = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', clean);
    }
  }
})();
